<script>
import { SysVars } from '../main';
import axios from "axios";
import { apiDownload, apiORDSpost, urlORDS } from "../shared/api-functions";
import Trap from "vue-focus-lock";

export default {
  components: {
    Trap
  },
  data() {
    return {
      showForm: false,
      metadata: this.$store.getters.getEntities.metadata,
      ctaValidate: null,

      contasConfiguradas: [],
      contasExistentes: [],
      listBancos: [],

      cta: null,
      codCtaEditing: null,
      editing: false,
    };
  },

  computed: {
  },

  methods: {
    handleCloseEditing() {
        this.editing = false
        this.codCtaEditing = null
        this.showForm = false
    },

    handleNovoBanco(item, isCta) {
        this.codCtaEditing = isCta ? item.codcta : null
        this.editing = false
        
        if (isCta) {
            // Carrega dados de uma conta que ja existe na tabela CTA
            this.cta = {
                codcta: item.codcta,
                descricao: item.descricao,
                banco: item.banco,
                agencia: item.agencia,
                conta: item.conta,
                digito: item.digito,
                convenio: null,
                nrinscricao: null,
                clientid: null,
                clientsecret: null,
                negativacliente: 'N',
                tipocobranca: 'B',
                pmora: null,
                pmulta: null,
                codfil: item.codfil,
            }
        } else {
            // Criando do zero para um banco sem conta
            this.cta = {
                codcta: null,
                descricao: null,
                banco: item.banco,
                agencia: null,
                conta: null,
                digito: null,
                convenio: null,
                nrinscricao: null,
                clientid: null,
                clientsecret: null,
                negativacliente: 'N',
                tipocobranca: 'B',
                pmora: null,
                pmulta: null,
                codfil: null,
            }
        }
        
        this.setCtaValidate(item.banco)
        this.showForm = true
    },

    handleEdit(cta) {
        this.cta = JSON.parse(JSON.stringify(cta))
        this.codCtaEditing = this.cta.codcta
        this.setCtaValidate(cta.banco)
        this.editing = true
        this.showForm = true
    },

    handleSave () {
      //BOTAO SALVAR
      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
        } else {
          this.handlePost()
        }
      })
    },

    async handlePost() {
      let url = urlORDS(this.$store, 'fin/configuracobranca/');

      let payload = {
        cobranca: this.cta
      }

      try {
        const response = await axios.post(url, payload);
        this.$erpToastSuccess("Configuração gravada com sucesso");
        this.handleCloseEditing()
        this.loadData()
      } catch (error) {
        console.error("Erro ao configurar enviacobranca:", error);
        this.$erpToastError("Erro ao configurar cobranca: " + error);
        return
      }

    },

    setCtaValidate(bancoId) {
      const defaultValidate = {
        agencia: { validate: 'required|max:4', exibe: true },
        conta: { validate: 'required|max:10', exibe: true },
        digitoagencia: { validate: 'max:1', exibe: false },
        nrinscricao: { validate: 'max:15', exibe: false },
        convenio: { validate: 'max:10', exibe: false },
        clientid: { validate: 'max:100', exibe: false },
        clientsecret: { validate: 'max:100', exibe: false },
      }

      if (bancoId == '208') {
        this.ctaValidate = {
            ...defaultValidate,
            nrinscricao: { exibe: true, validate: 'max:20' },
            convenio: { exibe: true, validate: 'required|max:20' },
            clientid: { exibe: true, validate: 'required|min:1|max:50' },
            clientsecret: { exibe: true, validate: 'required|min:1|max:255' },
            conta: { exibe: true, validate: 'required|max:10' },
        }
      } else if (bancoId == '033') {
        this.ctaValidate = {
          ...defaultValidate,
          nrinscricao: { validate: 'required|max:15', exibe: true },
          clientid: { validate: 'required|max:100', exibe: true },
          clientsecret: { validate: 'required|max:100', exibe: true },
        }
      } else if (bancoId == '001') {
        this.ctaValidate = {
          ...defaultValidate,
          convenio: { validate: 'required|max:10', exibe: true },
          clientid: { validate: 'required|max:100', exibe: true },
          clientsecret: { validate: 'required|max:100', exibe: true },
        }
      } else if (bancoId == '341') {
        this.ctaValidate = {
          ...defaultValidate,
          clientid: { validate: 'required|max:100', exibe: true },
          clientsecret: { validate: 'required|max:100', exibe: true },
        }
      } else {
        this.ctaValidate = defaultValidate
      }
    },

    async loadData() {
      let url = urlORDS(this.$store, 'fin/configuracobranca/');

      try {
        const response = await axios.get(url);
        this.contasConfiguradas = response.data.contasConfiguradas || []
        this.contasExistentes = response.data.contasExistentes || []
        this.listBancos = response.data.bancosSemConta || []
      } catch (error) {
        this.$erpToastError("Erro lista cobranca: " + error);
        return
      }

      this.$nextTick(function() {
        jQuery('[data-toggle="tooltip"]').tooltip();
      });
    }
  },

  created() {
    this.loadData();
  }
};
</script>

<template>
  <div>
    <div>
      <div class="row mb-3">
        <div class="col-md-12 col-12 float-left">
          <h4 class="def-title">Configurar Cobrança Bancaria</h4>
        </div>
      </div>

      <div>
        <!-- 1. CONTAS CONFIGURADAS -->
        <div v-if="contasConfiguradas.length">
          <div class="row mb-4">
            <div class="col-md-12">
              <span class="lbl-deal-title mb-2 w-100">Contas com Cobrança Ativa</span>
            </div>
          </div>

          <div class="mainbox" v-for="conta in contasConfiguradas" :key="conta.codcta">
            <div class="mark-gray"></div>
            <div class="box p-2">
              <div class="row">
                <div class="col-md-1">
                  <img :src="conta.banco_url" style="padding: 10px; height: 55px" />
                </div>
                <div class="col-md-3">
                  <label class="lbl-list w-100">Banco</label><br>
                  <span class="data-list">{{ conta.nome }}</span><br>
                </div>
                <div class="col-md-3">
                  <label class="lbl-list w-100">Descrição da Conta</label><br>
                  <span class="data-list">{{ conta.descricao }}</span><br>
                </div>
                <div class="col-md-2 col-3 ml-auto d-flex">
                  <v-button
                    label="Editar"
                    @click="handleEdit(conta)" ></v-button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 2. CONTAS EXISTENTES (NAO CONFIGURADAS) -->
        <div v-if="contasExistentes.length">
          <div class="row my-4">
            <div class="col-md-12">
              <span class="lbl-deal-title mb-2 w-100">Suas Contas Bancárias (Para Ativar Cobrança)</span>
            </div>
          </div>

          <div class="mainbox" v-for="conta in contasExistentes" :key="conta.codcta">
            <div class="mark-gray"></div>
            <div class="box p-2">
              <div class="row">
                <div class="col-md-1">
                  <img :src="conta.banco_url" style="padding: 10px; height: 55px" />
                </div>
                <div class="col-md-1">
                  <label class="lbl-list w-100">Banco</label><br>
                  <span class="data-list">{{ conta.banco }}</span><br>
                </div>
                <div class="col-md-3">
                  <label class="lbl-list w-100">Descrição</label><br>
                  <span class="data-list">{{ conta.descricao }}</span><br>
                </div>
                <div class="col-md-3">
                  <label class="lbl-list w-100">Agência / Conta</label><br>
                  <span class="data-list">{{ conta.agencia }} / {{ conta.conta }}</span><br>
                </div>
                <div class="col-md-2 col-3 ml-auto d-flex">
                  <v-button
                    label="Configurar"
                    @click="handleNovoBanco(conta, true)" ></v-button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 3. BANCOS SEM CONTA -->
        <div v-if="listBancos.length">
          <div class="row my-4">
            <div class="col-md-12">
              <span class="lbl-deal-title mb-2 w-100">Outros Bancos (Novo Cadastro)</span>
            </div>
          </div>

          <div class="mainbox" v-for="banco in listBancos" :key="banco.banco">
            <div class="mark-gray"></div>
            <div class="box p-2">
              <div class="row">
                <div class="col-md-1">
                  <img :src="banco.banco_url" style="padding: 10px; height: 55px" />
                </div>
                <div class="col-md-1">
                  <label class="lbl-list w-100">Banco</label><br>
                  <span class="data-list">{{ banco.banco }}</span><br>
                </div>
                <div class="col-md-3">
                  <label class="lbl-list w-100">Nome do Banco</label><br>
                  <span class="data-list">{{ banco.nome }}</span><br>
                </div>
                <div class="col-md-2 col-3 ml-auto d-flex">
                  <v-button
                    label="Configurar"
                    @click="handleNovoBanco(banco, false)" ></v-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="row m-3" v-if="contasConfiguradas.length == 0 && contasExistentes.length == 0 && listBancos.length == 0">
          <div class="col-md-12 text-center">
            <label-title
              title="Nenhuma informação disponível"
            ></label-title>
          </div>
        </div>

      </div>
    </div>

    <!-- MODAL DE CONFIGURAÇÃO -->
    <div class="modal nb-modal-mask" v-if="showForm" style="display:block">
      <Trap>
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Configurar Cobrança Bancária</h5>
              <button type="button" class="close" @click="handleCloseEditing">
                <span>&times;</span>
              </button>
            </div>
            <div class="modal-body" style="max-height: 70vh; overflow-y: auto;">
              <div class="row p-3">
                <form-field v-model="cta.codfil" type="select2" col="6" :metadata="metadata.cta.codfil"
                    name="codfil" :v-errors="errors" v-validate="metadata.cta.codfil.validator"></form-field>
                <form-field v-model="cta.descricao" type="text" col="6" :metadata="metadata.cta.descricao"
                    name="descricao" :v-errors="errors" v-validate="metadata.cta.descricao.validator"></form-field>

                <div class="w-100"></div>

                <form-field v-model="cta.agencia" type="text" col="4" :metadata="metadata.cta.agencia"
                    name="agencia" :v-errors="errors" v-validate="ctaValidate.agencia.validate"
                    v-if="ctaValidate && ctaValidate.agencia"></form-field>
                <form-field v-model="cta.conta" type="text" col="4" :metadata="metadata.cta.conta"
                    name="conta" :v-errors="errors" v-validate="ctaValidate.conta.validate"
                    v-if="ctaValidate && ctaValidate.conta"></form-field>
                <form-field v-model="cta.digito" type="text" col="4" :metadata="metadata.cta.digito"
                    name="digito" :v-errors="errors" v-validate="metadata.cta.digito.validator"></form-field>

                <div class="w-100"></div>

                <form-field v-model="cta.nrinscricao" type="text" col="6" :metadata="metadata.cta.nrinscricao"
                    name="nrinscricao" :v-errors="errors" v-validate="ctaValidate.nrinscricao.validate"
                    v-if="ctaValidate && ctaValidate.nrinscricao && ctaValidate.nrinscricao.exibe"></form-field>
                <form-field v-model="cta.convenio" type="text" col="6" :metadata="metadata.cta.convenio"
                    name="convenio" :v-errors="errors" v-validate="ctaValidate.convenio.validate"
                    v-if="ctaValidate && ctaValidate.convenio && ctaValidate.convenio.exibe"></form-field>

                <div class="w-100"></div>

                <form-field v-model="cta.clientid" type="text" col="6" :metadata="metadata.cta.clientid"
                    name="clientid" :v-errors="errors" v-validate="ctaValidate.clientid.validate"
                    v-if="ctaValidate && ctaValidate.clientid && ctaValidate.clientid.exibe"></form-field>
                <form-field v-model="cta.clientsecret" type="text" col="6" :metadata="metadata.cta.clientsecret"
                    name="clientsecret" :v-errors="errors" v-validate="ctaValidate.clientsecret.validate"
                    v-if="ctaValidate && ctaValidate.clientsecret && ctaValidate.clientsecret.exibe"></form-field>

                <div class="w-100"></div>

                <form-field v-model="cta.pmulta" type="value" col="6" :metadata="metadata.cta.pmulta"
                    name="pmulta" :v-errors="errors" v-validate="metadata.cta.pmulta.validator"></form-field>
                <form-field v-model="cta.pmora" type="value" col="6" :metadata="metadata.cta.pmora"
                    name="pmora" :v-errors="errors" v-validate="metadata.cta.pmora.validator"></form-field>

                <div class="w-100"></div>

                <form-field v-model="cta.negativacliente" type="select" col="6" :metadata="metadata.cta.negativacliente"
                    name="negativacliente" :v-errors="errors" v-validate="metadata.cta.negativacliente.validator"></form-field>
                <form-field v-model="cta.tipocobranca" type="select" col="6" :metadata="metadata.cta.tipocobranca"
                    name="tipocobranca" :v-errors="errors" v-validate="metadata.cta.tipocobranca.validator"></form-field>
              </div>
            </div>
            <div class="modal-footer">
              <v-button label="Cancelar" @click="handleCloseEditing"></v-button>
              <v-button label="Confirmar" :success="true" @click="handleSave"></v-button>
            </div>
          </div>
        </div>
      </Trap>
    </div>
  </div>
</template>

<style>
.nb-modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: block;
  overflow-y: auto;
  transition: opacity 0.3s ease;
}
</style>



// WEBPACK FOOTER //
// src/forms/cobranca-config.vue